<template>
  <Modal
    :modal="modal"
    title="Sequenciais Inexistentes"
    customTitleClass="body-1 font-weight-bold"
    @close="$emit('close')"
  >
  <div slot="header-right">
    <v-btn fab small text @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
    <div slot="inner-body" class="mt-5">
      <v-form
        v-model="valid"
        lazy-validation
        ref="form"
        @submit.prevent="searchSequenciais"
      >
        <Input
          :value="sequencial1"
          @input="sequencial1 = $event"
          type="number"
          label="Sequencial 01"
          placeholder="Exemplo: 1"
          filled
          :rules="[rules.required]"
        />
        <Input
          :value="sequencial2"
          @input="sequencial2 = $event"
          type="number"
          label="Sequencial 02"
          placeholder="Exemplo: 10"
          filled
          :rules="[rules.required]"
        />

        <Button
          text="Buscar"
          block
          color="primary"
          type="submit"
          :loading="loading"
        />
      </v-form>
      <p v-if="error" class="text-center mt-5 red--text">{{ error }}</p>
      
      <v-col v-if="!!nonExistentSequenciais.length" class="pa-0">
        <v-subheader class="pl-0 font-weight-medium">Sequenciais Inexistentes ({{ nonExistentSequenciais.length }})</v-subheader>
        <v-chip
          v-for="(item, i) in nonExistentSequenciais"
          :key="i"
          class="ma-1"
          label
        >
          <strong>{{ item }}</strong>
        </v-chip>
      </v-col>
      <p class="text-center mt-5" v-else>Nenhum sequencial encontrado</p>
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { producaoService } from '@/services/producaoService';

export default {
  name: 'ModalSequenciais',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    id_producao: {
      default: ''
    }
  },
  components: {
    Modal: () => import('@/components/shared/modal/Modal'),
    Input: () => import('@/components/shared/Input'),
    Button: () => import('@/components/shared/Button'),
  },
  data: () => ({
    sequencial1: '',
    sequencial2: '',
    nonExistentSequenciais: [],
    valid: true,
    error: '',
    loading: false,
  }),
  computed: {
    ...mapGetters(['rules'])
  },
  methods: {
    async searchSequenciais() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        if (this.sequencial1 && +this.sequencial1 > +this.sequencial2) {
          this.error = "Sequenciais inválidos";
          this.loading = false;
          return;
        }
  
        this.nonExistentSequenciais = await producaoService.showNonExistentSequenciaisBetween2Numbers(this.id_producao, +this.sequencial1, +this.sequencial2);
        this.error = '';
        this.loading = false;
      }
    }
  }
}
</script>

<style>

</style>